// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pui-collapsible {
  margin-bottom: 10px;
}
.elements-center {
  text-align: -webkit-center;
}
.review-comment {
  margin: 0px 20px 20px;
}
.review-buttons {
  display: inline-flex;
  margin-bottom: 10px;
}
.approve-button, .reject-button {
  margin: auto;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
